import React, { useState, useEffect, useContext } from 'react';
import ICourseRostersReport from '../../model/ICourseRostersReport'
import { Grid, GridColumn, GridSortChangeEvent } from '@progress/kendo-react-grid'
import ReportsService from '../../services/ReportsService'
import { Year } from '../../services/AppContext'
import { LocationContext } from '../../services/AppContext'
import { CompositeFilterDescriptor, filterBy, orderBy, SortDescriptor } from "@progress/kendo-data-query";
import { ExcelExport,ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Row, Col } from 'react-bootstrap';
import { IDropDownValue } from '../../services/Utility';
import schoolService from '../../services/SchoolService';


interface ILocation {
    changeExcelRef: any;
    selectedReport: any
}


const initialDataState = {
    skip: 0,
    take: 10,
};



const initialFilter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
};

const initialSort: Array<SortDescriptor> = [
    { field: "courseLocation", dir: "desc" },
];

export default function CourseRostersReport(props: ILocation) {
    const { locationCode } = useContext(LocationContext);
    const { orginalSchoolYear } = useContext(Year);
    const [page, setPage] = React.useState(initialDataState);

    const [filter, setFilter] = React.useState(initialFilter);
    const [sort, setSort] = React.useState(initialSort);
    const [rowData, setRowData] = useState<ICourseRostersReport[]>([]);
    const _export = React.useRef<ExcelExport | null>(null);
    const [orginalSchoolList, setOrginalSchoolList] = useState<IDropDownValue[]>([]);
    const [schoolList, setSchoolList] = useState<IDropDownValue[]>([]);

    const [schoolLocation, setSchoolLocation] = React.useState<string>(locationCode);
    interface Reports {
        reportName: string;
        reportValue: string;
        isDefaultSelected: number;
      }


    const pageChange = (event: any) => {
        setPage(event.page);
    };


    const onFilterChange = (e: any) => {
        setPage(initialDataState)
        setFilter(e.filter)
    }

    const GetCourseRostersReport = () => {
        ReportsService.GetCourseRostersReport(+orginalSchoolYear.id,schoolLocation).then(response => {
            setRowData(response.data)
            props.changeExcelRef(_export)
        })
    }
    const filterData = (filter: any) => {
        let data = orginalSchoolList.slice();
        return filterBy(data, filter);
      }
      const filterChange = (event: any) => {
        let data = filterData(event.filter)
        setSchoolList(data)
      } 
      const handleChange = (event: any) => {
        const selectedSchool = event.target.value;
        setSchoolLocation(selectedSchool.id)
        props.selectedReport()
      }
      const changeSelectedSchool = (event: any) => {
        const selectedSchool = event.target.value;
        setSchoolLocation(selectedSchool.id);
      }
      const TeacherFullNameCell = (props:any) => {
        const { dataItem } = props;
        return (
          <td>
            {dataItem.teacherFirstName} {dataItem.teacherLastName}
          </td>
        );
      };
      const StudentFullNameCell = (props:any) => {
        const { dataItem } = props;
        return (
          <td>
            {dataItem.studentFirstName} {dataItem.studentLastName}
          </td>
        );
      };
    useEffect(() => {
        schoolService.getData().then(response => {
            let dropDownData = response.data.map((sl: any) => ({
              id: sl.locationCode, 
              text: sl.locationCode + ' -- ' + sl.schoolName
            }));
            setOrginalSchoolList(dropDownData)
            setSchoolList(dropDownData)
        })
        GetCourseRostersReport();
    }, [orginalSchoolYear.id,props.selectedReport,schoolLocation]);

    return (
      <div>
                <Row className="mb-3">
          <Col sm="4" className="text-right">
          <DropDownList
      data={schoolList}
      defaultValue={schoolList.find(x=>x.id==locationCode)}
      textField="text"
      filterable={true}
      onChange={handleChange}
      onFilterChange={filterChange}
      onClose={changeSelectedSchool}
      style={{ maxWidth: '350px', width: "100%" }}
      
    />
          </Col>
        </Row>
        <ExcelExport data={rowData} ref={_export} fileName={"Course_Rosters_Report" + ' ' + new Date().toDateString()}>
                    <ExcelExportColumn  field="courseLocation"  title="School"></ExcelExportColumn>
                    <ExcelExportColumn field="courseName"  title="Course"></ExcelExportColumn>
                    <ExcelExportColumn field="section"  title="Section"></ExcelExportColumn>
                    <ExcelExportColumn field="sectionLocation"  title="Section Location"></ExcelExportColumn>
                    <ExcelExportColumn field="studentId"  title="Student Id"></ExcelExportColumn>
                    <ExcelExportColumn field="studentLocation"  title="Student Location"></ExcelExportColumn>
                    <ExcelExportColumn field="studentFirstName"  title="Student First Name"></ExcelExportColumn>
                    <ExcelExportColumn field="studentLastName"  title="Student Last Name"></ExcelExportColumn>
                    <ExcelExportColumn field="tor"  title="TOR"></ExcelExportColumn>
                    <ExcelExportColumn field="teacherFirstName"  title="TOR First Name"></ExcelExportColumn>
                    <ExcelExportColumn field="teacherLastName"  title="TOR Last Name"></ExcelExportColumn>
        </ExcelExport>
                    <Grid
                    data={filterBy(rowData, filter).slice(page.skip, page.take + page.skip)}
                    skip={page.skip}
                    take={page.take}
                    total={rowData.length}
                    pageSize={page.take}
                    pageable={{ pageSizes: [10, 25, 50, 100], info: true }}
                    onPageChange={pageChange}
                    filterable={true}
                    filter={filter}
                    onFilterChange={onFilterChange}
                    style={{ overflowX: "auto" }}
                    scrollable={"none"}>
                    <GridColumn  field="courseLocation" filterable={false} title="School"></GridColumn>
                    <GridColumn field="courseName" filterable={false} title="Course"></GridColumn>
                    <GridColumn field="studentId" filterable={false} title="Student Id"></GridColumn>
                    <GridColumn field="studentLocation" filterable={false} title="Student Location"></GridColumn>
                    <GridColumn cell={StudentFullNameCell}filterable={false} title="Student Name" />
                    <GridColumn field="tor" filterable={false} title="TOR"></GridColumn>
                    <GridColumn field="teacherLocation" filterable={false} title="TOR Location"></GridColumn>
                    <GridColumn cell={TeacherFullNameCell}filterable={false} title="TOR Name" />
                </Grid>
                </div>
    )
}